import { format } from "date-fns";
import { useAddEvidence } from "../../api/evidence";
import { errorToast, successToast } from "../../toast";
import CreateEvidenceForm from "../CreateEvidenceForm";
import { LinkEvidenceFormValues } from "../CreateEvidenceForm/CreateEvidenceFormValues";
import DialogBox from "../DialogBox";

export type CreateEvidenceDialogProps = {
    isOpen: boolean;
    onClose: (evidenceSubmitted: boolean) => void;
    evidenceTypeId: number;
    evidenceTypeName: string;
    emissionsSourceId?: number;
    emissionsSourceName?: string;
};

const CreateEvidenceDialog = ({
    isOpen,
    onClose,
    evidenceTypeId,
    evidenceTypeName,
    emissionsSourceId,
    emissionsSourceName,
}: CreateEvidenceDialogProps) => {
    const [addEvidence, isAddingEvidence] = useAddEvidence();

    const handleCreateEvidenceFormSubmission = async (
        value: LinkEvidenceFormValues
    ) => {
        if (value.validFromDate !== null && value.validToDate !== null) {
            const response = await addEvidence({
                ...value,
                evidenceTypeId,
                emissionsSourceId,
                validFromDate: format(value.validFromDate, "yyyy-MM-dd"),
                validToDate: format(value.validToDate, "yyyy-MM-dd"),
            });

            if (!response.success) {
                errorToast(
                    "There was a problem linking evidence - please try again"
                );
                return;
            }

            successToast("Evidence linked");
            onClose(true);
        }
    };

    return (
        <DialogBox
            title="Link evidence"
            isOpen={isOpen}
            onClose={() => onClose(false)}
        >
            {evidenceTypeId && (
                <CreateEvidenceForm
                    evidenceTypeName={evidenceTypeName}
                    emissionsSourceName={emissionsSourceName}
                    isLoading={isAddingEvidence}
                    isOpen={isOpen}
                    onSubmit={handleCreateEvidenceFormSubmission}
                    onCancel={() => onClose(false)}
                />
            )}
        </DialogBox>
    );
};

export default CreateEvidenceDialog;
